import { getCookie } from '@carvana/futilities';
import { useEffect } from 'react';
import Cookies from '~/constants/srp/cookies';
import useSearchAnalyzeTrigger from './useSearchAnalyzeTrigger';

export const SEARCH_ANALYZE_TRIGGER_EVENT = 'search-analyze-trigger';

export type SearchAnalyzeTriggerEventDetail = {
  source?: string;
  timestamp?: number;
  [key: string]: unknown;
};

export type SearchAnalyzeTriggerEvent =
  CustomEvent<SearchAnalyzeTriggerEventDetail>;

export default function useSearchAnalyzeEventListener(): void {
  const triggerSearch = useSearchAnalyzeTrigger();
  const isEnabled = getCookie(Cookies.enableSearchExplainer) === 'true';

  useEffect(() => {
    if (!isEnabled) return;

    const handleSearchAnalyzeTrigger = (event: Event) => {
      console.log(
        'Search Analyze Retrigger event received:',
        (event as SearchAnalyzeTriggerEvent).detail
      );

      triggerSearch();
    };

    window.addEventListener(
      SEARCH_ANALYZE_TRIGGER_EVENT,
      handleSearchAnalyzeTrigger
    );

    return () => {
      window.removeEventListener(
        SEARCH_ANALYZE_TRIGGER_EVENT,
        handleSearchAnalyzeTrigger
      );
    };
  }, [isEnabled, triggerSearch]);
}
